"use strict";

import React from "react";
import PropTypes from "prop-types";
import scriptLoader from "react-async-script-loader";
import GpsUtils from "./GpsUtils";

class ElevationChart extends React.Component {
  static propTypes = {
    data: PropTypes.array.isRequired,
    routeId: PropTypes.string.isRequired,
    moveCursor: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.eleMin = Infinity;
    this.eleMax = 0;
  }

  distanceEleStream() {
    const data = this.props.data;
    let distance = 0;
    let distanceEleStream = [];

    for (let i = 0; i < data.length; i++) {
      if (i !== 0) {
        const pp = data[i - 1];
        const dist = GpsUtils.distanceBetweenPoints(data[i], pp);
        distance += dist;
      }

      const ele = data[i].ele;
      distanceEleStream.push([distance / 1000, ele]);

      if (ele < this.eleMin) {
        this.eleMin = ele;
      }

      if (ele > this.eleMax) {
        this.eleMax = ele;
      }
    }
    console.log(this.eleMax, this.eleMin);
    return distanceEleStream;
  }

  componentWillReceiveProps({ isScriptLoaded, isScriptLoadSucceed }) {
    if (isScriptLoaded && !this.props.isScriptLoaded) {
      // load finished
      if (isScriptLoadSucceed) {
        this.chart();
      }
    }
  }

  tooltipFormatter(tooltip) {
    let res = [];
    res.push("<b>Dist:</b> " + Math.round(tooltip.x * 10) / 10 + " km");
    for (let i = 0; i < tooltip.points.length; i++) {
      const point = tooltip.points[i];
      if (point.series.name === "Ele") {
        res.push("<b>Alt:</b> " + Math.round(point.y) + " m");
      }
    }
    return res.join("<br />");
  }

  tooltipPositioner(labelWidth, labelHeight, point, chart) {
    let xPos;
    if (chart.plotSizeX - point.plotX < 125) {
      xPos = point.plotX - 55;
    } else {
      xPos = point.plotX + 80;
    }
    return { x: xPos, y: 40 };
  }

  xAxisFormatter(value) {
    return value;
  }

  yAxisFormatter(value) {
    return value;
  }

  eventMouseOver(obj) {
    const index = obj.series.data.indexOf(obj);
    this.props.moveCursor(index);
  }

  chart() {
    let that = this;
    let chart = new Highcharts.Chart({
      chart: {
        renderTo: "chart-canvas-" + this.props.routeId,
        alignTicks: true,
        ignoreHiddenSeries: true,
        type: "splice",
        zoomType: "xy",
        height: 400,
        spacingLeft: 0,
      },
      title: { text: "" },
      credits: { enabled: false },
      series: [
        {
          name: "Ele Shadow",
          data: this.distanceEleStream(),
          yAxis: 0,
          color: "rgba(255,255,255, 1)", // Shadow color (semi-transparent)
          lineWidth: 16, // Thicker line for the shadow
          type: "area", // Using line type for shadow
          zIndex: 0, // Ensure it's behind the main series
          showInLegend: false,
          fillOpacity: 1,
          fillColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, // Vertical gradient
            stops: [
              [0, "rgba(255,163,1, 0.5)"], // Starting color (semi-transparent)
              [1, "rgba(255,163,1, 0)"], // Ending color (fully transparent)
            ],
          },
        },
        {
          name: "Ele",
          data: this.distanceEleStream(),
          yAxis: 0,
          color: "#252a4099",
          lineWidth: 2.5,
          type: "area",
          zIndex: 1,
          showInLegend: false,
          fillOpacity: 0,
          fillColor: "rgba(255,255,255,0)",
        },
      ],
      tooltip: {
        shared: true,
        followPointer: true,
        animation: false,
        borderColor: "#CBCBCB",
        shadow: false,
        hideDelay: 0,
        formatter: function () {
          return that.tooltipFormatter(this);
        },
        positioner: function (labelWidth, labelHeight, point) {
          return that.tooltipPositioner(labelWidth, labelHeight, point, chart);
        },
      },
      plotOptions: {
        series: {
          marker: { enabled: false },
          point: {
            events: {
              mouseOver: function () {
                that.eventMouseOver(this);
              },
            },
          },
          states: {
            hover: { enabled: false },
          },
        },
      },

      xAxis: {
        title: {
          text: "km",
          align: "high", // Moves the title to the right end of the x-axis
          style: {
            fontSize: "12px",
            color: "rgba(0,0,0,0.5)",
            font: "Outfit",
          },
        },
        labels: {
          style: {
            color: "#c3c3c3",
            fontSize: "11px",
            font: "Outfit",
          },
          formatter: function () {
            return that.xAxisFormatter(this.value);
          },
        },
        crosshair: {
          zIndex: 5,
          color: "#AAA",
        },
        lineColor: "#EEE",
        lineWidth: 1,
        maxPadding: 0,
        minPadding: 0,
        min: 0,
        gridLineColor: "#efefef",
        gridLineWidth: 1,
        gridLineColor: "#efefef",
        gridLineDashStyle: "Dash",
        minorGridLineWidth: 0.5,
        minorTickInterval: "auto",
        minorGridLineColor: "#efefef",
        tickLength: 0,
        tickInterval: 1,
      },

      yAxis: [
        {
          title: {
            text: "",
            align: "high",
            rotation: 0,
            y: 0,
            x: 0,
            style: {
              fontSize: "11px",
              color: "rgba(0,0,0,0.4)",
              fontFamily: "Outfit",
            },
          },
          lineWidth: 1,
          lineColor: "#EEE",
          labels: {
            style: {
              color: "#c3c3c3",
              fontSize: "11px",
              fontFamily: "Outfit",
            },
            formatter: function () {
              return that.yAxisFormatter(parseInt(this.value - (this.value % 5)));
            },
          },
          startOnTick: false,
          endOnTick: false,
          softMin: null,
          softMax: null,
          min: this.eleMin,
          max: this.eleMax,
          minRange: 0.1,
          gridLineColor: "#efefef",
          gridLineWidth: 1,
          gridLineColor: "#efefef",
          gridLineDashStyle: "Dash",
          minorGridLineWidth: 0.5,
          minorTickInterval: "auto",
          minorGridLineColor: "#efefef",
        },
      ],
    });
    return chart;
  }

  render() {
    return <div id={"chart-canvas-" + this.props.routeId} />;
  }
}

export default scriptLoader("https://code.highcharts.com/highcharts.js")(ElevationChart);
